exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo {\n  height: 70px;\n}\n\n.header {\n  background-color: #FFFFFF;\n  height: 100%;\n  padding: 10px;\n  color: #4e4084;\n}\n\n.header-custom__app-name {\n  color: #FFFFFF;\n  font-size: 24px;\n  font-weight: 300;\n  font-family: \"Source Sans Pro\", \"Helvetica Neue\", \"Helvetica\";\n}\n@media (min-width: 374px) {\n  .header-custom__app-name {\n    font-size: 24px;\n  }\n}\n@media (min-width: 600px) {\n  .header-custom__app-name {\n    font-size: 42px;\n  }\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/sass-loader/lib/loader.js!./src/js/components/Header/header.scss
// module id = 106
// module chunks = 0